import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth() || {};
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="animate-pulse text-sm text-muted-foreground">Loading your workspace…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
